
import { Component, Vue, Inject } from "vue-property-decorator";
import nyNetwork from "@/api/nyBaseNetwork";
import DZModelLandOrder from "@/views/订单管理/土地/model/DZModelLandOrder";
import DZModelPage from "@/model/DZModelPage";
import DZModelHomestayOrder from "@/views/订单管理/民宿/model/DZModelHomestayOrder";

@Component({
    components: {}
})
export default class Index extends Vue {

    excelName = '民宿订单.xls';

    json_fields = {
        '订单号':'orderNum',
        '标题':'title',
        '预约人':'name',
        '电话':'phone',
        '创建时间':'createTime'
    }

    $refs: any;

    table_height = 0;

    created() {
        this.action_list_data()
    }

    mounted() {
        this.$nextTick(() => {
            const mainHeight = this.$refs.mainContent.offsetHeight;
            const mainScreen = this.$refs.mainScreen.offsetHeight;
            this.table_height = mainHeight - mainScreen - 50;
        })
    }

    m_page = new DZModelPage(10);

    list_homestayOrder : Array<DZModelHomestayOrder> = [];

    action_list_data(){
        nyNetwork.net('民宿预约列表',this.m_page,data =>{
            this.list_homestayOrder = data.list
            this.m_page.total = data.total
        })
    }

    handleSizeChange(val){
        this.m_page.pageSize = val
        this.action_list_data()
    }

    selections = []
    handleSelectionChange(val) {
        this.selections = val;
    }

    toPrint(){
        this.$nyPrint.printTable(this.selections,this.json_fields,this.excelName)
    }

    actionOpenPage(item){
        const url = `http://www.nongzhaibao.com/show_homestay/${item.id}`
        window.open(url, '_blank')  // 新标签
    }
}
